import type { Destino } from "./destinos"

/**
 * Cómo se busca un módulo o una vista (05/11). Puro, para probarlo sin pantalla.
 *
 * ⚠ **Sin tildes ni mayúsculas, y cada palabra por su lado**: «pago por ejecutar»
 * encuentra «Pagos por ejecutar» y «tesoreria» encuentra «Tesorería». Basta con que
 * cada palabra escrita aparezca en el nombre, en dónde vive o en sus otras palabras.
 */

export const MAXIMO_RESULTADOS = 8

export function normalizar(texto: string): string {
  return texto.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().replace(/\s+/g, " ").trim()
}

/** Más alto, más arriba. Cero: no es lo que se busca. */
function puntuar(destino: Destino, consulta: string, palabras: string[]): number {
  const nombre = normalizar(destino.etiqueta)
  const todo = `${nombre} ${normalizar(destino.donde)} ${normalizar(destino.palabras)}`
  if (!palabras.every((p) => todo.includes(p))) return 0
  if (nombre === consulta) return 100
  if (nombre.startsWith(consulta)) return 80
  const delNombre = nombre.split(" ")
  if (palabras.every((p) => delNombre.some((n) => n.startsWith(p)))) return 60
  if (palabras.every((p) => nombre.includes(p))) return 40
  return 20
}

export function buscar(destinos: Destino[], texto: string): Destino[] {
  const consulta = normalizar(texto)
  if (consulta === "") return []
  const palabras = consulta.split(" ")
  return destinos
    .map((destino, orden) => ({ destino, orden, puntos: puntuar(destino, consulta, palabras) }))
    .filter((r) => r.puntos > 0)
    .sort(
      (a, b) =>
        b.puntos - a.puntos ||
        a.destino.etiqueta.length - b.destino.etiqueta.length ||
        a.orden - b.orden,
    )
    .slice(0, MAXIMO_RESULTADOS)
    .map((r) => r.destino)
}
